<template>

</template>
<style scoped>

</style>
<template>
    <!--
        作者：wangxw
        时间：2020-06-10
        描述：页面-首页
    -->
    <div class="homePageEdit-main">
        <div v-loading="loading" class="diy-container clearfix">

            <!--类别选择-->
            <div class="diy-menu">
                <Type v-if="!loading" :defaultData="defaultData"></Type>
            </div>

            <!--手机diy容器-->
            <div class="diy-phone">
                <Model v-if="!loading" ref="model" :form="form" :defaultData="defaultData" :diyData="diyData"></Model>
            </div>

            <!--参数设置-->
            <div class="diy-info">
                <Params v-if="!loading" :form="form" :defaultData="defaultData" :diyData="diyData"></Params>
            </div>

            <!--提交-->
            <!--        <div class="common-button-wrapper">-->
            <!--            <el-button size="small" type="primary" @click="Submit()" :loading="loading">保存</el-button>-->
            <!--        </div>-->
        </div>
        <div class="footer">
            <el-button type="primary" @click="goPreview" :disabled="!merchant_id">{{$t('主页预览')}}</el-button>
            <el-button type="primary" @click="pageBack" :disabled="!merchant_id">{{$t('恢复初始默认页面')}}</el-button>
        </div>
    </div>

</template>

<script>
import {deepClone} from '@/utils/base.js'
import PageApi from '@/api/page.js';
import SettingApi from '@/api/setting.js';
import Type from '@/components/buildStore/website/homePageEdit/Type.vue';
import Model from '@/components/buildStore/website/homePageEdit/Model.vue';
import Params from '@/components/buildStore/website/homePageEdit/Params.vue';
import {submitResEnum} from "../../../../logic/buildStore";

export default {
    components: {
        /*组件类别*/
        Type,
        /*组件信息*/
        Model,
        /*参数信息*/
        Params
    },
    data() {
        return {
            /*是否正在加载*/
            loading: true,
            /*默认数据*/
            defaultData: {},
            /*组件数据列表*/
            diyData: {
                items: []
            },
            opts: {},
            /*表单对象*/
            form: {
                umeditor: {},
                /*当前选中*/
                curItem: {},
                /*当前选中的元素（下标）*/
                selectedIndex: -1
            },
            merchant_id: 0,
            page_id: 0,
        };
    },
    async created() {
        /*获取列表*/
        await this.getData();
        await this.getWebsiteInfo();
    },
    methods: {
        async getData() {
            let self = this;
            let res = await PageApi.editHome({}, true)
            if (res && res.code === 1) {
                self.defaultData = res.data.defaultData;
                self.diyData = res.data.jsonData;
                self.form.curItem = self.diyData.page;
                self.opts = res.data.opts;
                self.page_id = res.data.page_id
            } else {

            }
            self.loading = false;
            if (this.$route.query.selectedIndex && Number(this.$route.query.selectedIndex)) {
                this.form.selectedIndex = Number(this.$route.query.selectedIndex);
            }
        },

        async getWebsiteInfo() {
            let res = await SettingApi.storeDetail({}, true)
            if (res && res.code === 1) {
                this.merchant_id = res.data && res.data.app && res.data.app.merchant_id ? res.data.app.merchant_id : 0
            } else {
                this.$message({
                    message: self.$t('获取预览网站失败,请检查网络或联系管理员'),
                    type: 'error'
                })
            }
        },

        /*新增Diy组件*/
        onAddItem: function (key) {
            // 复制默认diy组件数据
            let item = deepClone(this.defaultData[key]), cur_index = 0;
            if (this.form.selectedIndex < 0) {
                cur_index = 0;
                this.diyData.items.unshift(item);
            } else {
                cur_index = this.form.selectedIndex + 1;
                this.diyData.items.splice(cur_index, 0, item);
            }
            // 编辑当前选中的元素
            this.$refs.model.onEditer(cur_index);
        },

        /*上架*/
        async onSubmit() {
            let self = this;
            self.loading = true;
            let params = self.diyData;
            let page_id = self.page_id;
            let res = await PageApi.SavePage(
                {
                    params: JSON.stringify(params),
                    page_id: page_id
                },
                true
            )
            if (res && res.code === 1) {
                await this.getData();
                return submitResEnum.success
            } else {
                return submitResEnum.submitFailed
            }
            self.loading = false;
        },

        goPreview() {
            window.open(`${window.location.origin}/${this.merchant_id}`)
        },
        async pageBack() {
            let self = this;
            let page_id = self.page_id;
            let res = await PageApi.BackPage(
                {
                    page_id: page_id
                },
                true
            )
            if (res && res.code === 1) {
                this.$message({
                    message: self.$t('撤回成功'),
                    type: 'success',
                })
                await this.getData();
            }
        }
    },

};
</script>

<style lang="scss">
@import '@/styles/page/diy.scss';

.homePageEdit-main {
    .footer {
        margin-top: 15px;
        display: flex;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/website/websiteEdit/homePageEdit.vue